module.exports = __webpack_public_path__ + "static/top-8f11e11643b5fbba23b0a942dfa9fc4d.png";